__turbopack_context__.v({
  "dd": "lMEG6W_dd",
  "dl": "lMEG6W_dl",
  "dt": "lMEG6W_dt",
  "pending": "lMEG6W_pending",
  "root": "lMEG6W_root",
});
